module.exports = __webpack_public_path__ + "static/img/add_img_icon.82831af3.svg";